export default "__VITE_ASSET__c6b24da4__"